import { PublicMetadataRepository } from '@lib/api/repository/public-metadata';

export default class PublicMetadataService {
  constructor(private readonly repository: PublicMetadataRepository) {}
  find(path: string, signal?: AbortSignal) {
    return this.repository.find(path, signal);
  }
}
